<template>
  <drag
    :transfer-data="caseInfo"
    style="cursor:grab"
    @drag="dragging = true"
    @dragend="dragging = false"
    :draggable="!isAssigning"
  > 
    <!-- Actual element -->
    <v-hover v-slot="{ hover }">
      <v-card
        v-click-outside="onClickOutside"
        rounded="lg"
        class="mb-6"
        :style="{ opacity: dragging ? 0 : 1 }"
        :elevation="hover ? 3 : 0"
        @click.native="toggleExpand()"
        :loading="isAssigning"
      >
        
        <v-card-text>
          <div class="d-flex mb-3">
            <!-- name -->
            <h3 class="my-1" style="word-break: break-all">
              {{ full_name || 'N&frasl;A'}}
            </h3>

            <!-- floating buttons -->
            <div class="ml-auto d-flex">
              <!-- view button -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="hover"
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="$emit('view')"
                  >
                    <v-icon>mdi-account-details</v-icon>
                  </v-btn>
                </template>
                <span>View Case</span>
              </v-tooltip>
              <!-- assign button -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="hover"
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="$emit('assign')"
                  >
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Assign Case</span>
              </v-tooltip>
            </div>
          </div>

          <!-- keymaps -->
          <case-details
            v-if="expand"
            :case-info="caseInfo"
          ></case-details>

          <!-- values -->
          <v-row
            v-else
            v-for="key in keyMap"
            :key="key.key"
            dense
          >
            <v-col
              cols='12'
              class="d-flex" 
            >
              <!-- text -->
              <span class="d-block">
                {{ key.text }}
              </span>
              <!-- value -->
              <span class="ml-auto font-weight-bold">
                {{ (key.prepend || '')
                  +getDeepProperty(key.key)
                  +(key.append || '') }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>
    
    <!-- element placeholder on drag-->
    <!-- to ensure it element is on top left corner -->
    <!-- position relative to cursor   -->
    <div
      slot="image"
      class="pa-3"
    >
      <v-card
        rounded="lg"
        elevation="10"
        class="mb-6"
        width="250px"
      >
        <v-card-text>
          <!-- name -->
          <h3 class="text-left mb-3">{{ full_name }}</h3>
          <!-- values -->
          <v-row
            v-for="key in keyMap"
            :key="key.key"
            dense
          >
            <v-col
              cols='12'
              class="d-flex" 
            >
              <!-- text -->
              <span class="d-block">
                {{ key.text }}
              </span>
              <!-- value -->
              <span
                v-if="key.key !== 'consultation_call_datetime'"
                class="ml-auto font-weight-bold"
              >
                {{ (key.prepend || '')
                  +getDeepProperty(key.key)
                  +(key.append || '') }}
              </span>
              <span
                v-else
                class="ml-auto font-weight-bold"
              >
                {{ (key.prepend || '')
                  +getDeepProperty(key)
                  +(key.append || '') }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </drag>
</template>

<script>
  import { get } from 'lodash'
  import moment from 'moment'

  export default {
    name: 'SidebarCases',

    components: {
      CaseDetails: () => import('./CaseDetails.vue')
    },

    props: {
      caseInfo: { 
        type: Object,
        default:()=>{}
      }
    },

    data() {
      return {
        expand: false,
        dragging: false,
        keyMap: [
          { text: 'Case Title', key: 'health_concern' },
          { text: 'Case No', key: 'case_number' },
          { text: 'Case', key: 'id', prepend: 'Case #' },
          { text: 'Consult', key: 'consultations.length' },
          { text: 'Status', key: 'status' },
          { text: 'Schedule', key: 'consultation_call_datetime' },
        ]
      }
    },

    filters: {
      datetime: function (date) {
        return moment(date).format('MMM. D, YYYY, h:mmA');
      },
    },

    computed: {
      assignId() { return this.$store.getters['cases/assignId'] },
      isAssigning() {
        if (this.assignId == this.caseInfo.id)
          return this.$store.getters['cases/isAssigning']
        else
          return false
      },
      patient() {
        return this.caseInfo.patient
      },
      user() {
        return this.caseInfo.patient.patient
      },
      full_name() {
        var user = this.caseInfo.patient
        var patient = this.caseInfo.patient.patient
        var name = '';
        if (patient !== null) {
          if (Object.prototype.hasOwnProperty.call(patient, 'full_name')) {
            if (patient.full_name && patient.full_name !== null) {
              name = patient.full_name
            }
            else {
              if (patient.first_name || patient.last_name) {
                name = `${patient.first_name} ${patient.last_name}`;
              }
              else {
                name = user.email
              }
            }
          }
          else {
            name = user.email
          }
        }
        else {
          name = user.email
        }
        return name;
      }
    },

    mounted() {
      //
    },

    methods: {
      getDatetime() {
        //
      },
      getDeepProperty(stringProperty) {
        if (stringProperty == 'consultation_call_datetime') {
          var index = this.caseInfo.consultations.length - 1;
          return this.$options.filters.datetime(this.caseInfo.consultations[index].call_datetime)
        }
        else
          return get(this.caseInfo, stringProperty)
      },
      // view more case info
      toggleExpand() {
        this.expand = !this.expand
      },
      onClickOutside() {
        this.expand = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  span {
    font-size: .9em;
  }
  
  .v-card {
    transition: box-shadow .4s;
  }
</style>